import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect, useMemo } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { CustomUIRenderer, ModalCustomUIRenderer } from './CustomUIRenderer';
import { UIKitRenderer } from './UIKitRenderer';
import { makeFrame, makeModalThreeLOPromptForCustomUI, makeThreeLOPromptForCustomUI } from '../../components';
import { ForgeUIExtensionAnalyticsContext } from '../../analytics';
import { isCustomUI } from '../../utils/isCustomUI';
export var ForgeUIRenderer = function ForgeUIRenderer(props) {
  var accountId = props.accountId,
    bridge = props.bridge,
    client = props.client,
    components = props.components,
    consentMessage = props.consentMessage,
    contextIds = props.contextIds,
    customBridgeMethods = props.customBridgeMethods,
    dialogs = props.dialogs,
    entryPoint = props.entryPoint,
    extension = props.extension,
    extensionData = props.extensionData,
    extensionPayload = props.extensionPayload,
    extensionViewData = props.extensionViewData,
    hasModalConsentPrompt = props.hasModalConsentPrompt,
    height = props.height,
    width = props.width,
    isIframeHidden = props.isIframeHidden,
    isIframeResizable = props.isIframeResizable,
    getContextToken = props.getContextToken,
    loadingComponent = props.loadingComponent,
    locale = props.locale,
    localId = props.localId,
    mentionProvider = props.mentionProvider,
    modalExtension = props.modalExtension,
    modalStyles = props.modalStyles,
    modalProvider = props.modalProvider,
    onConsentModalClose = props.onConsentModalClose,
    onConsentSuccess = props.onConsentSuccess,
    onConsentInitialization = props.onConsentInitialization,
    onError = props.onError,
    onForgeDocUpdated = props.onForgeDocUpdated,
    onIframeLoad = props.onIframeLoad,
    onInitialRender = props.onInitialRender,
    product = props.product,
    timezone = props.timezone,
    getModalWidth = props.getModalWidth,
    onModalExtensionClose = props.onModalExtensionClose,
    onSuccess = props.onSuccess,
    onAppError = props.onAppError;
  var cloudId;
  var workspaceId;
  if ('cloudId' in props) {
    cloudId = props.cloudId;
  } else if ('workspaceId' in props) {
    workspaceId = props.workspaceId;
  }
  var cloudOrWorkspaceId = cloudId ? {
    cloudId: cloudId
  } : {
    workspaceId: workspaceId
  };
  useEffect(function () {
    onInitialRender === null || onInitialRender === void 0 || onInitialRender();
  }, [onInitialRender]);
  var extensionId = extension.id,
    environmentId = extension.environmentId,
    environmentType = extension.environmentType;
  var coreData = useMemo(function () {
    return {
      workspaceId: workspaceId,
      cloudId: cloudId,
      localId: localId || extensionId,
      environmentId: environmentId,
      environmentType: environmentType
    };
  }, [cloudId, environmentId, environmentType, extensionId, localId, workspaceId]);
  var getThreeLOPrompt = useCallback(function () {
    return {
      ThreeLOPrompt: modalExtension || hasModalConsentPrompt ? makeModalThreeLOPromptForCustomUI({
        appName: extension.properties.title,
        isBlanketHidden: true,
        onClose: onConsentModalClose
      }) : makeThreeLOPromptForCustomUI({
        appName: extension.properties.title,
        onSuccess: onConsentSuccess,
        message: consentMessage,
        onInitialization: onConsentInitialization
      })
    };
  }, [extension.properties.title, consentMessage, hasModalConsentPrompt, modalExtension, onConsentSuccess, onConsentModalClose, onConsentInitialization]);
  var customUIProps = {
    accountId: accountId,
    bridge: bridge,
    client: client,
    consentMessage: consentMessage,
    contextIds: contextIds,
    coreData: coreData,
    customBridgeMethods: customBridgeMethods,
    dialogs: dialogs,
    entryPoint: entryPoint,
    extension: extension,
    extensionData: extensionData,
    extensionPayload: extensionPayload,
    extensionViewData: extensionViewData,
    getContextToken: getContextToken,
    getThreeLOPrompt: getThreeLOPrompt,
    height: height,
    loadingComponent: loadingComponent,
    locale: locale,
    localId: localId,
    mentionProvider: mentionProvider,
    modalExtension: modalExtension,
    modalStyles: modalStyles,
    modalProvider: modalProvider,
    onConsentModalClose: onConsentModalClose,
    onConsentSuccess: onConsentSuccess,
    onError: onError,
    onForgeDocUpdated: onForgeDocUpdated,
    onIframeLoad: onIframeLoad,
    product: product,
    timezone: timezone,
    isIframeHidden: isIframeHidden,
    isIframeResizable: isIframeResizable
  };
  return /*#__PURE__*/React.createElement(ForgeUIExtensionAnalyticsContext, {
    extensionId: extension.id,
    localId: localId || extension.id
  }, /*#__PURE__*/React.createElement("span", {
    hidden: true,
    id: "forge-ui-renderer"
  }), isCustomUI(extension, entryPoint) ? modalExtension ?
  /*#__PURE__*/
  // getModalWidth not applied here since all modal extensions are defaulted to medium width
  React.createElement(ModalCustomUIRenderer, _extends({}, customUIProps, {
    onClose: onModalExtensionClose
  })) : /*#__PURE__*/React.createElement(CustomUIRenderer, _extends({}, customUIProps, {
    getModalWidth: getModalWidth,
    width: width
  })) : /*#__PURE__*/React.createElement(UIKitRenderer, _extends({
    coreData: coreData,
    getThreeLOPrompt: getThreeLOPrompt,
    accountId: accountId,
    client: client,
    contextIds: contextIds,
    extension: extension,
    extensionData: extensionData,
    extensionViewData: extensionViewData,
    product: product,
    bridge: bridge,
    customBridgeMethods: customBridgeMethods,
    components: _objectSpread(_objectSpread({}, components), {}, {
      Frame: makeFrame(function (inputProps) {
        return /*#__PURE__*/React.createElement(CustomUIRenderer, _extends({}, customUIProps, {
          extension: _objectSpread(_objectSpread({}, extension), {}, {
            properties: _objectSpread(_objectSpread({}, extension.properties), inputProps)
          })
          // Ensure extensions that are rendered as entryPoints aren't passing through the very same entryPoint to the Frame
        }, fg('platform_enable_frame_rendering_for_entry_points') && {
          entryPoint: undefined
        }, {
          // Ensures Frame is always resized to the full height of the content
          // Required because Jira leaves isIframeResizable as false
          isIframeResizable: true
        }));
      })
    }),
    consentMessage: consentMessage,
    entryPoint: entryPoint,
    getContextToken: getContextToken,
    locale: locale,
    localId: localId,
    mentionProvider: mentionProvider,
    modalExtension: modalExtension,
    onConsentSuccess: onConsentSuccess,
    onForgeDocUpdated: onForgeDocUpdated,
    timezone: timezone,
    onConsentModalClose: onConsentModalClose,
    onError: onError,
    loadingComponent: loadingComponent,
    extensionPayload: extensionPayload,
    onSuccess: onSuccess
  }, cloudOrWorkspaceId, {
    onAppError: onAppError
  })));
};